import {
  LoyaltySpecFormType,
  LoyaltySpecResponseType,
} from './loyalty-domain.type';

export const transformLoyaltySpecs = (body: LoyaltySpecFormType) => ({
  ...body,
  excludedProducts: body.excludedProducts?.map(prod => prod.product),
  dynamicPointsAwardRatio: body.dynamicPointsAwardRatio?.reduce(
    (acc, value) => {
      if (!acc[value.day]) {
        acc[value.day] = [];
      }
      acc[value.day].push({
        startTime: value.startTime,
        endTime: value.endTime,
        pointsAwardRatio: value.additionalData,
      });
      return acc;
    },
    {},
  ),
});

export const transformLoyaltySpecsResponse = (
  response: LoyaltySpecResponseType,
) => {
  const savedProducts = response.excludedProducts?.map(product => ({
    id: product.internalId ?? product.externalId,
    label: product.displayInfoTitlesList[0],
    category: product.type,
    product,
  }));

  return {
    ...response,
    excludedProducts: savedProducts,
    dynamicPointsAwardRatio: Object.entries(
      response.dynamicPointsAwardRatio ?? {},
    ).reduce((acc, [key, value]) => {
      acc = acc.concat(
        value.map(val => ({
          day: key,
          startTime: val.startTime,
          endTime: val.endTime,
          additionalData: val.pointsAwardRatio,
        })),
      );
      return acc;
    }, []),
  };
};
